import { render } from "./studioCourse.vue?vue&type=template&id=7f1393a4&scoped=true"
import script from "./studioCourse.vue?vue&type=script&lang=js"
export * from "./studioCourse.vue?vue&type=script&lang=js"

import "./studioCourse.vue?vue&type=style&index=0&id=7f1393a4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1393a4"]])

export default __exports__